import { decode } from 'jsonwebtoken';

import { DEMO_STUDENT_JWT } from 'constants/system';

import getJwtKey from 'core/axios/getJwtKey';

import { getCookie } from 'utils/cookies';
import { ensureObject } from 'utils/objects';

const getJwt = ({ decoded = false } = {}) => {
  const JWT_KEY = getJwtKey();
  const isDemoJWT = JWT_KEY === DEMO_STUDENT_JWT;
  const isNgrok = window.location.hostname.includes('ngrok-free.app');

  const jwtData =
    isDemoJWT || isNgrok
      ? localStorage.getItem(DEMO_STUDENT_JWT)
      : getCookie(JWT_KEY);

  return decoded ? ensureObject(decode(jwtData)) : jwtData;
};

export default getJwt;
